import type { ReactNode } from 'react';
import { useWebShell } from '../../contexts/WebShellContext';
import { Header } from './Header';
import { NavBar } from './NavBar';
import { WsStatusPill } from '../atoms/WsStatusPill';
import styles from './Layout.module.css';

export interface LayoutProps {
  children: ReactNode;
  title?: string;
  headerRight?: ReactNode;
  hideHeader?: boolean;
  hideNav?: boolean;
}

export function Layout({
  children,
  title,
  headerRight,
  hideHeader,
  hideNav,
}: LayoutProps): JSX.Element {
  // Inside the standalone web shell (`/app/*`), `<AppShell>` already renders
  // `<WebHeader />` + `<WebNavBar />`. Suppress the Mini App's own chrome to
  // avoid stacked navbars (NN/g H4, H8).
  const { inWebShell } = useWebShell();
  const renderNav = !hideNav && !inWebShell;

  return (
    <div className={styles.layout}>
      <WsStatusPill />
      {hideHeader ? null : <Header title={title} right={headerRight} />}
      <main className={styles.content}>{children}</main>
      {renderNav ? <NavBar /> : null}
    </div>
  );
}
